import * as ActionTypes from 'constants';
import moment from 'moment';

const mapCreator = (
  state = {
    maps_list: [],
    current_map: null,
    tmp_map_id: null,
    current_feature: null,          //  'current_feature' is represented on the map. 'current_feature_saved'
    current_feature_saved: null,    //    has been stored in the database.
    storm_date: moment(new Date(), 'MM/DD/YYYY').toDate(),
    swath_opacity: 0.3,
    drawing_mode: null,
    places: [],
    marker_types: [],
    current_marker_type: null,
    deleting_map_id: null,
    deleting_feature_id: null,
    show_deleting_map_modal: false,
    show_delete_feature_confirmation: false,
    show_edit_warning_modal: false,
    show_create_map_modal: false,
    show_edit_map_modal: false,
    show_disconnected_socket_error: false,
    show_marker_editor_icon_modal: false,
    show_marker_editor_info_window_modal: false,
    show_delete_map_creator_marker_type_modal: false,
    deleting_markers: false,
    uploading_kml_layers: false,
    deleting_kml_layer: false,
    uploading_polygons: false,
    uploading_info_window_image: false,
    tmp_info_window_image_file: null,
    processing_map_creator_marker: false,
    hidden_maps: [],
    hidden_features: [],
    hidden_kml_layers: []
  }, { type, payload }) => {
    switch(type) {
      case ActionTypes.TOGGLE_WAITING_FOR_MAP_CREATOR_RESPONSE: {
        return { ...state, waiting_for_response: payload != null ? payload: !state.waiting_for_response };
      }
      case ActionTypes.INIT_MAP_CREATOR_MAPS_LIST: {
        return { ...state, maps_list: payload };
      }
      case ActionTypes.SET_CURRENT_MAP_CREATOR_MAP: {
        return { ...state, current_map: payload };
      }
      case ActionTypes.UPDATE_MAP_PROPERTIES: {
        const { map_id, properties } = payload;
        const found_map = state.maps_list.find(m => m._id == map_id);
        if(found_map) {
          const updated_map = { ...found_map, properties: { ...found_map.properties, ...properties } };
          return {
            ...state,
            maps_list: state.maps_list.map(m => m._id == map_id ? updated_map : m),
            current_map: state.current_map && state.current_map._id == map_id ? updated_map : state.current_map
          };
        }
      }
      case ActionTypes.UPDATE_CURRENT_MAP_PROPERTIES: {
        return {
          ...state,
          current_map: {
            ...state.current_map,
            properties: {
              ...state.current_map.properties,
              ...payload
            }
          }
        };
      }
      case ActionTypes.SET_CURRENT_MAP_CREATOR_FEATURE: {
        const { feature_id, map_id } = payload;
        const found_map = state.maps_list.find(m => m._id == map_id);
        if(found_map) {
          if(found_map.properties.finished) {
            return { ...state, tmp_map_id: found_map._id, show_edit_warning_modal: true };
          }
          else {
            const found_feature = found_map.features.find(f => f.properties._id == feature_id);
            return {
              ...state,
              current_feature: found_feature,
              current_feature_saved: found_feature,
              current_map: found_map,
              drawing_mode: null
            };
          }
        }
      }
      case ActionTypes.UPDATE_CURRENT_MAP_FEATURE: {
        return state;
        // const { feature } = payload;
        // const updated_map = {
        //   ...state.current_map,
        //   features: state.current_map.features.map(f => f.properties._id == feature.properties._id ? feature : f)
        // };
        // return {
        //   ...state,
        //   current_feature: feature,
        //   current_map: updated_map,
        //   maps_list: state.maps_list.map(m => m._id == updated_map._id ? updated_map : m)
        //  };
      }
      case ActionTypes.UPDATE_MAP_STORM_DATE: {
        return {
          ...state,
          storm_date: payload,
          current_map: null,
          current_feature: null,
          maps_list: []
        };
      }
      case ActionTypes.UPDATE_SWATH_OPACITY: {
        return { ...state, swath_opacity: payload };
      }
      case ActionTypes.UPDATE_DRAWING_MODE: {
        let updated_current_feature;
        if(
          payload == null ||
          payload == state.drawing_mode
        ) {
          updated_current_feature = state.current_feature;
        }
        else {
          updated_current_feature = null;
        }
        return {
          ...state,
          drawing_mode: payload,
          current_feature: updated_current_feature
        };
      }
      case ActionTypes.INIT_NEW_MAP: {
        return {
          ...state,
          current_map: {
            type : 'FeatureCollection',
            features : [],
            properties : {
              price : 19900,
              publish_date : new Date(),
              storm_date : state.storm_date || new Date(),
              date_created : new Date()
            }
          },
          show_create_map_modal: true,
          current_feature: null
        };
      }
      case ActionTypes.CANCEL_NEW_MAP: {
        return { ...state, current_map: null, current_feature: null, show_create_map_modal: false };
      }
      case ActionTypes.ADD_NEW_MAP: {
        const { map, update_current } = payload;
        return {
          ...state,
          maps_list: [ ...state.maps_list, payload.map ],
          current_map: update_current ? payload.map : state.current_map,
          show_create_map_modal: false,
        };
      }
      case ActionTypes.INIT_EDIT_MAP: {
        const found_map = typeof payload == 'string' ? state.maps_list.find(m => m._id == payload) : payload;
        if(found_map.properties.finished) {
          return { ...state, tmp_map_id: found_map._id, show_edit_warning_modal: true };
        }
        else {
          const current_map = !state.current_map ? found_map : state.current_map && state.current_map._id == found_map._id ? found_map : state.current_map;
          return {
            ...state,
            current_map,
            show_edit_map_modal: true,
            show_edit_warning_modal: false,
            tmp_map_id: null
          };
        }
      }
      case ActionTypes.CANCEL_EDIT_MAP: {
        return { ...state, show_edit_map_modal: false };
      }
      case ActionTypes.EDIT_MAP_SUCCESS: {
        const { map } = payload;
        const found_map = state.maps_list.find(m => m._id == map._id);
        const updated_map = { ...(found_map || {}), properties: { ...found_map.properties, ...map.properties } };
        if(found_map) {
          return {
            ...state,
            maps_list: state.maps_list.map(m => m._id == updated_map._id ? updated_map : m),
          };
        }
      }
      case ActionTypes.EDIT_MAP_FAILURE: {
        const { map } = payload;
        const prev_current_map = state.maps_list.find(m => m._id == map._id);
        return {
          ...state,
          current_map: prev_current_map && (state.current_map || {})._id == (prev_current_map || {})._id ? prev_current_map : state.current_map
        };
      }
      case ActionTypes.INIT_DELETE_MAP: {
        return { ...state, deleting_map_id: payload, show_deleting_map_modal: true };
      }
      case ActionTypes.CANCEL_DELETE_MAP: {
        return { ...state, deleting_map_id: null, show_deleting_map_modal: false };
      }
      case ActionTypes.DELETE_MAP_SUCCESS: {
        const { map_id } = payload;
        return {
          ...state,
          deleting_map_id: null,
          show_deleting_map_modal: false,
          current_map: state.current_map._id == map_id ? null : state.current_map,
          maps_list: state.maps_list.filter(m => m._id != state.deleting_map_id),
        };
      }
      case ActionTypes.DELETE_MAP_FAILURE: {
        return { ...state, deleting_map_id: null, show_deleting_map_modal: false };
      }
      case ActionTypes.CREATE_MAP_FEATURE_SUCCESS: {
        const { feature, map_id } = payload;
        const found_map = state.maps_list.find(m => m._id == map_id);
        if(found_map != null) {
          const updated_map = { ...found_map, features: [ ...found_map.features, feature ] };
          const current_map_updated = (state.current_map || {})._id == map_id;
          return {
            ...state,
            current_map: state.current_map && state.current_map._id == updated_map._id ? updated_map : state.current_map,
            maps_list: state.maps_list.map(m => m._id == updated_map._id ? updated_map : m),
          };
        }
      }
      case ActionTypes.EDIT_MAP_FEATURE_SUCCESS: {
        const { map_id, feature, user_id } = payload;
        const found_map = state.maps_list.find(m => m._id == map_id);
        if(found_map) {
          const updated_map = { ...found_map, features: found_map.features.map(f => f.properties._id == feature.properties._id ? feature : f) };
          const current_map_updated = (state.current_map || {})._id == map_id;
          const current_feature_updated = ((state.current_feature || {}).properties || {})._id == feature.properties._id;
          return {
            ...state,
            current_feature_saved: current_feature_updated ? feature : state.current_feature_saved,
            current_feature: current_feature_updated ? feature : state.current_feature,
            current_map: current_map_updated ? updated_map : state.current_map,
            maps_list: state.maps_list.map(m => m._id == updated_map._id ? updated_map : m),
          };
        }
      }
      case ActionTypes.EDIT_MAP_FEATURE_FAILURE: {
        if(state.current_feature_saved) {
          const map_with_feature = state.maps_list.find(m => {                                //  Needed as current_map may
            return m.features.find(f => f._id == state.current_feature_saved._id) != null;    //  have changed during ws request
          });                                                                                 //
          if(map_with_feature) {
            const updated_map = {
              ...map_with_feature,
              features: map_with_feature.features.map(f => f._id == state.current_feature_saved ? state.current_feature_saved : f)
            };
            return {
              ...state,
              current_feature: state.current_feature.properties._id == state.current_feature_saved.properties._id ? state.current_feature_saved : state.current_feature,
              current_map: state.current_map && state.current_map._id == updated_map._id ? updated_map : state.current_map,
              maps_list: state.maps_list.map(m => m._id == updated_map ? updated_map : m)
            };
          }
        }
      }
      case ActionTypes.INIT_DELETE_MAP_FEATURE: {
        return {
          ...state,
          deleting_feature_id: typeof payload == 'string' ? payload : payload._id,
          show_delete_feature_confirmation: true
        };
      }
      case ActionTypes.CANCEL_DELETE_MAP_FEATURE:
      case ActionTypes.DELETE_MAP_FEATURE_FAILURE: {
        return { ...state, deleting_feature_id: null, show_delete_feature_confirmation: false };
      }
      case ActionTypes.DELETE_MAP_FEATURE_SUCCESS: {
        const { map_id, feature_id } = payload;
        const found_map = state.maps_list.find(m => m._id == map_id);
        if(found_map) {
          const updated_map = { ...found_map, features: found_map.features.filter(f => f._id != feature_id) };
          return {
            ...state,
            current_feature: state.current_feature && state.current_feature.properties._id == feature_id ? null : state.current_feature,
            current_map: state.current_map && state.current_map._id == found_map._id ? updated_map : state.current_map,
            maps_list: state.maps_list.map(m => m._id == found_map._id ? updated_map : m),
            current_feature_saved: state.current_feature_saved && state.current_feature_saved._id == feature_id ? null : state.current_feature_saved,
            deleting_feature_id: null,
          };
        }
      }
      case ActionTypes.TOGGLE_MAP_HIDDEN: {
        const map_id = typeof payload == 'string' ? payload : payload._id;
        const map_hidden = state.hidden_maps.includes(map_id);
        const updated_hidden_maps =
          map_hidden ?
          state.hidden_maps.filter(m => m != map_id) :
          [ ...state.hidden_maps, map_id ];
        return { ...state, hidden_maps: updated_hidden_maps };
      }
      case ActionTypes.TOGGLE_FEATURE_HIDDEN: {
        const feature_id = typeof payload == 'string' ? payload : payload._id;
        const feature_hidden = state.hidden_features.includes(feature_id);
        const updated_hidden_features =
          feature_hidden ?
          state.hidden_features.filter(f => f != feature_id) :
          [ ...state.hidden_features, feature_id ];
        return { ...state, hidden_features: updated_hidden_features };
      }
      case ActionTypes.TOGGLE_SHOW_DISCONNECTED_SOCKET_ERROR: {
        return { ...state, show_disconnected_socket_error: payload != null ? payload : !state.show_disconnected_socket_error };
      }
      case ActionTypes.TOGGLE_HIDE_KML_LAYER: {
        const layer_hidden = state.hidden_kml_layers.includes(payload);
        const updated_hidden_kml_layers =
          layer_hidden ?
          state.hidden_kml_layers.filter(l => l != payload) :
          [ ...state.hidden_kml_layers, payload ];
        return { ...state, hidden_kml_layers: updated_hidden_kml_layers };
      }
      case ActionTypes.TOGGLE_UPLOADING_KML_LAYERS: {
        return { ...state, uploading_kml_layers: payload != null ? payload: !state.uploading_kml_layers };
      }
      case ActionTypes.TOGGLE_DELETING_KML_LAYERS: {
        return { ...state, deleting_kml_layer: payload != null ? payload : !state.deleting_kml_layer };
      }
      case ActionTypes.MOVE_MAP_FEATURE_SUCCESS: {
        const { from_map_id, to_map_id, feature_id } = payload;
        const found_from_map = state.maps_list.find(m => m._id == from_map_id);
        const found_to_map = state.maps_list.find(m => m._id == to_map_id);
        if(found_from_map && found_to_map) {
          const found_feature = found_from_map.features.find(f => f._id == feature_id);
          const updated_from_map = { ...found_from_map, features: found_from_map.features.filter(f => f._id != feature_id) }
          const updated_to_map = { ...found_to_map, features: [ ...found_to_map.features, found_feature ] };
          return {
            ...state,
            current_map: updated_to_map,
            maps_list: state.maps_list.map(m => m._id == updated_from_map ? updated_from_map : m._id == updated_to_map ? updated_to_map : m),
          };
        }
      }
      case ActionTypes.TOGGLE_UPLOADING_POLYGONS: {
        return { ...state, uploading_polygons: payload != null ? payload : !state.uploading_polygons };
      }
      case ActionTypes.CANCEL_EDIT_MAP_WARNING: {
        return {
          ...state,
          show_edit_warning_modal: false,
          show_edit_map_modal: false,
          tmp_map_id: null
        };
      }
      case ActionTypes.TOGGLE_SHOW_EDIT_MAP_WARNING_MODAL: {
        return { ...state, show_edit_warning_modal: payload != null ? payload : !state.show_edit_warning_modal };
      }
      case ActionTypes.INIT_MAP_CREATOR_MARKER_TYPES: {
        return { ...state, marker_types: payload };
      }
      case ActionTypes.HANDLE_MAP_CREATOR_PLACES_CHANGE: {
        return { ...state, places: payload };
      }
      case ActionTypes.TOGGLE_PROCESSING_MAP_CREATOR_MARKER: {
        return { ...state, processing_map_creator_marker: payload != null ? payload : !state.uploading_map_creator_marker };
      }
      case ActionTypes.UPDATE_CURRENT_MAP_CREATOR_MARKER_TYPE: {
        return {
          ...state,
          current_marker_type: payload,
          show_delete_map_creator_marker_type_modal: state.deleting_markers ? true : false
        };
      }
      case ActionTypes.TOGGLE_SHOW_MARKER_EDITOR_ICON_MODAL: {
        return { ...state, show_marker_editor_icon_modal: payload != null ? payload : !state.show_marker_editor_icon_modal };
      }
      case ActionTypes.TOGGLE_SHOW_MARKER_EDITOR_INFO_WINDOW_MODAL: {
        return { ...state, show_marker_editor_info_window_modal: payload != null ? payload : !state.show_marker_editor_info_window_modal };
      }
      case ActionTypes.TOGGLE_UPLOADING_MAP_CREATOR_INFO_WINDOW_IMAGE: {
        return { ...state, uploading_info_window_image: payload != null ? payload : !state.uploading_info_window_image };
      }
      case ActionTypes.TOGGLE_DELETING_MARKERS: {
        return { ...state, deleting_markers: payload != null ? payload : !state.deleting_markers };
      }
      case ActionTypes.TOGGLE_SHOW_DELETE_MAP_CREATOR_MARKER_TYPE_MODAL: {
        return { ...state, show_delete_map_creator_marker_type_modal: payload != null ? payload : !state.show_delete_map_creator_marker_type_modal };
      }
      case ActionTypes.UPDATE_MAP_CREATOR_TMP_INFO_WINDOW_IMAGE: {
        return {
          ...state,
          tmp_info_window_image_file: payload,
          uploading_info_window_image: false
        };
      }
      case ActionTypes.DELETE_MAP_CREATOR_MARKER_TYPE_SUCCESS: {
        return { ...state, marker_types: state.marker_types.filter(m => m._id != payload.marker_id) };
      }
      case ActionTypes.TOGGLE_SHOW_EDIT_MAP_MODAL: {
        return { ...state, show_edit_map_modal: payload != null ? payload : !state.show_edit_map_modal };
      }
      case ActionTypes.TOGGLE_SHOW_CREATE_MAP_MODAL: {
        return { ...state, show_create_map_modal: payload != null ? payload : !state.show_create_map_modal };
      }
      case ActionTypes.SET_MAP_CREATOR_PROPERTIES: {
        return {
          ...state,
          ...payload,
        };
      }
      default: {
        return state;
      }
    }

    return state;
  };

  export default mapCreator;



// WEBPACK FOOTER //
// ./src/common/reducers/mapCreator.js